import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import { isNil } from "ramda";

import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { IDockerSiteData } from "types/api/webAppApiInterface";

import ChangeOwncloudConfig from "../actions/owncloudActions/ChangeOwncloudConfig";
import ConfigureSmtp from "../actions/owncloudActions/ConfigureSmtp";
import ResetCache from "../actions/owncloudActions/ResetCache";
import ScanFiles from "../actions/owncloudActions/ScanFiles";

const OwncloudConf = ({ siteData }: { siteData: IDockerSiteData }): ReactElement => {
 const checkSmtp = (): boolean => {
  return (
   isNil(siteData.owncloud.config.mail_domain) &&
   isNil(siteData.owncloud.config.mail_smtphost) &&
   isNil(siteData.owncloud.config.mail_smtpname)
  );
 };

 return (
  <Stack textAlign="left" pt={2}>
   <Stack direction="row" alignItems="center" spacing={1} pb={1}>
    <Typography fontWeight="bold" variant="unboundedTitle" fontSize={14}>
     SMTP
    </Typography>
   </Stack>
   {!checkSmtp() ? (
    <>
     <Stack direction="row">
      <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
       <FormattedMessage id="docker.website.domain" />
      </Typography>
      <Typography variant="subtitle2">{`${
       siteData.owncloud.config.mail_domain || "not selected"
      }`}</Typography>
     </Stack>
     <Stack direction="row">
      <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
       <FormattedMessage id="docker.website.fromAddress" />
      </Typography>
      <Typography variant="subtitle2">{`${
       siteData.owncloud.config.mail_from_address || "not selected"
      }`}</Typography>
     </Stack>
     <Stack direction="row">
      <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
       <FormattedMessage id="docker.website.smtpMode" />
      </Typography>
      <Typography variant="subtitle2">{`${
       siteData.owncloud.config.mail_smtpmode || "not selected"
      }`}</Typography>
     </Stack>
     <Stack direction="row">
      <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
       <FormattedMessage id="docker.website.smtpAuthType" />
      </Typography>
      <Typography variant="subtitle2">{`${
       siteData.owncloud.config.mail_smtpauthtype || "not selected"
      }`}</Typography>
     </Stack>
     <Stack direction="row">
      <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
       <FormattedMessage id="docker.website.smtpAuth" />
      </Typography>
      <Typography variant="subtitle2">{`${
       siteData.owncloud.config.mail_smtpauth || "not selected"
      }`}</Typography>
     </Stack>
     <Stack direction="row">
      <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
       <FormattedMessage id="docker.website.smtpName" />
      </Typography>
      <Typography variant="subtitle2">{`${
       siteData.owncloud.config.mail_smtpname || "not selected"
      }`}</Typography>
     </Stack>
     <Stack direction="row">
      <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
       <FormattedMessage id="docker.website.smtpPassword" />
      </Typography>
      <Typography variant="subtitle2">{`${
       siteData.owncloud.config.mail_smtppassword || "not selected"
      }`}</Typography>
     </Stack>
     <Stack direction="row">
      <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
       <FormattedMessage id="docker.website.smtpHost" />
      </Typography>
      <Typography variant="subtitle2">{`${
       siteData.owncloud.config.mail_smtphost || "not selected"
      }`}</Typography>
     </Stack>
     <Stack direction="row">
      <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
       <FormattedMessage id="docker.website.smtpPort" />
      </Typography>
      <Typography variant="subtitle2">{`${
       siteData.owncloud.config.mail_smtpport || "not selected"
      }`}</Typography>
     </Stack>
     <Stack direction="row">
      <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
       <FormattedMessage id="docker.website.smtpSecure" />
      </Typography>
      <Typography variant="subtitle2">{`${
       siteData.owncloud.config.mail_smtpsecure || "not selected"
      }`}</Typography>
     </Stack>
    </>
   ) : (
    <>
     <Stack spacing={1}>
      <Typography variant="subtitle2" fontStyle="italic">
       <FormattedMessage id="docker.website.smtpNotCreated" />
      </Typography>
      <Stack direction="row">
       <ConfigureSmtp id={siteData.id} mail_domain={siteData.site_name} />
      </Stack>
     </Stack>
    </>
   )}
   <Divider sx={{ my: 1 }} />
   <Stack direction="row" alignItems="center" spacing={1}>
    <Typography fontWeight="bold" variant="unboundedTitle" fontSize={14}>
     Actions
    </Typography>
   </Stack>
   <Stack direction="row">
    <ResetCache id={siteData.id} />
    <ScanFiles id={siteData.id} />
    {!checkSmtp() && <ChangeOwncloudConfig id={siteData.id} />}
   </Stack>
  </Stack>
 );
};

export default OwncloudConf;
